import { render, staticRenderFns } from "./segments-nav-editable-tab.vue?vue&type=template&id=5fad952e"
import script from "./segments-nav-editable-tab.vue?vue&type=script&lang=js"
export * from "./segments-nav-editable-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports